import { 
    Form, 
    Input, 
    Modal, 
    Button, 
    Space,
    Divider,
    Row as AntRow,
    Col
} from "antd";
import { 
    EditOutlined, 
    CloseOutlined,
    BankOutlined
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { editPublisherRequest } from "../../redux/controller";
import { useDispatchRoot } from "../../redux/store";
import { confirmCloseModal } from '../modalEditBook/CModalConfirmClose';

interface MyProps {
    open: boolean;
    data?: any;
    setOpenModalEdit: React.Dispatch<React.SetStateAction<boolean>>;
}

const CModalEditPublisher = (props: MyProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
    
    const dispatch = useDispatchRoot();
    const [form] = Form.useForm();
    const values = Form.useWatch([], form);

    useEffect(() => {
        if (props.data) {
            form.setFieldsValue({
                name: props.data.name,
                description: props.data.description || ''
            });
            setHasChanges(false);
        }
    }, [props.data]);

    useEffect(() => {
        const currentValues = form.getFieldsValue();
        const hasFormChanges = 
            currentValues.name !== props.data?.name ||
            currentValues.description !== (props.data?.description || '');
        
        setHasChanges(hasFormChanges);
    }, [values]);

    const handleEditPublisher = async () => {
        setIsLoading(true);
        try {
            const formValues = form.getFieldsValue();
            const bodyRequest = {
                id: props.data?.id,
                name: formValues.name,
                description: formValues.description,
            };
            
            await dispatch(editPublisherRequest(bodyRequest));
            
            props.setOpenModalEdit(false);
        } catch (error) {
            console.error("Error editing publisher:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancelEditPublisher = () => {
        confirmCloseModal({
            hasChanges,
            onConfirm: () => {
                resetForm();
                props.setOpenModalEdit(false);
            },
            title: 'Xác nhận đóng',
            content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal chỉnh sửa nhà xuất bản?'
        });
    };

    const resetForm = () => {
        setHasChanges(false);
        form.resetFields();
    };

    return (
        <Modal
            open={props.open}
            onCancel={handleCancelEditPublisher}
            title={
                <Space>
                    <EditOutlined />
                    <span>Chỉnh sửa nhà xuất bản</span>
                </Space>
            }
            className="publisher-edit-modal"
            footer={null}
            width={600}
            destroyOnClose
            maskClosable={true}
        >
            <div className="modal-content">
                <Form
                    initialValues={props.data}
                    form={form}
                    className="publisher-form"
                    layout="vertical"
                    onFinish={handleEditPublisher}
                >
                    <AntRow gutter={[16, 12]}>
                        <Col span={24}>
                            <Form.Item
                                label={
                                    <Space>
                                        <BankOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                        <span>Tên nhà xuất bản</span>
                                    </Space>
                                }
                                name="name"
                                rules={[{ required: true, message: 'Tên nhà xuất bản không được để trống!' }]}
                            >
                                <Input
                                    placeholder="Nhập tên nhà xuất bản (ví dụ: NXB Kim Đồng)"
                                    className="form-input"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label={
                                    <Space>
                                        <BankOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                        <span>Mô tả về nhà xuất bản</span>
                                    </Space>
                                }
                                name="description"
                            >
                                <Input.TextArea
                                    placeholder="Nhập mô tả về nhà xuất bản (tùy chọn)"
                                    className="form-textarea"
                                    rows={3}
                                    maxLength={1000}
                                    showCount
                                />
                            </Form.Item>
                        </Col>
                    </AntRow>
                    
                    <Divider style={{ margin: '16px 0' }} />
                    
                    <div className="modal-actions">
                        <Button
                            onClick={handleCancelEditPublisher}
                            className="cancel-button"
                            icon={<CloseOutlined />}
                        >
                            Hủy
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="save-button"
                            icon={<EditOutlined />}
                            loading={isLoading}
                        >
                            Cập nhật
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};

export default CModalEditPublisher;
